import React from 'react';

const ThemePreviewFooter = () => {
  return <div className='h-[30px] bg-[#22252E]' />;
};
export default ThemePreviewFooter;
